import { ShinySkeletonTextBody, ShinySkeletonText } from './helpers/skeletonHelpers';
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function CompactEventSkeleton() {
  return /*#__PURE__*/_jsxs(CardWrapper, {
    "data-selenium-test": "timeline-card-skeleton",
    "data-test-id": "timeline-card-skeleton",
    marginBlockEnd: "0",
    padding: "400",
    paddingInlineStart: "900",
    paddingInlineEnd: "400",
    borderWidth: "0",
    children: [/*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(View, {
        flexGrow: 1,
        children: /*#__PURE__*/_jsx(ShinySkeletonText, {
          width: 150
        })
      }), /*#__PURE__*/_jsx(View, {
        justifySelf: "end",
        children: /*#__PURE__*/_jsx(ShinySkeletonText, {
          width: 180
        })
      })]
    }), /*#__PURE__*/_jsx(View, {
      marginBlockStart: "300",
      children: /*#__PURE__*/_jsx(ShinySkeletonTextBody, {
        width: "100%"
      })
    })]
  });
}
export default CompactEventSkeleton;